
import React from 'react';
import { connect } from 'react-redux';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId, injectTestId } from '@cvent/nucleus-test-automation';
import Icon from '@cvent/nucleus-icon';
import { orderBy, map, isEmpty } from 'lodash';
import SpeakerDocumentStyles from './SpeakerDocumentStyles.less';
import { getFileIconClass } from './SpeakerDocumentFile';

function SpeakerDocuments({ documents, translate, speakerId, onDocumentDownload, ...rest }) {
  const renderDocuments = (speakerDocuments) => {
    return map(
      orderBy(speakerDocuments, document => document.name.toLowerCase()),
      document =>
        (
          <li
            onClick={() => onDocumentDownload(speakerId, document)}
            key={document.id} {...resolve(rest, 'list', 'speakerModalDocuments')}
            {...injectTestId(`speakerDocument-${document.id}`)} >
            <Icon icon={getFileIconClass(document.extension)} modifier={SpeakerDocumentStyles.icon}/>
            <a
              {...resolve(rest, 'speakerModalDocuments')}
              href={document.uri}
              target="_blank"
            >
              {document.name + '.' + document.extension}
            </a>
          </li>
        )
    );
  };
  if (!isEmpty(documents)) {
    const speakerDocumentClasses = { ...SpeakerDocumentStyles };
    return (
      <div
        {...resolve({ rest, classes: speakerDocumentClasses }, 'speakerDocumentContainer')}
        {...resolveTestId(rest, '-modal-documents')}>
        <div {...resolve(rest, 'speakerModalDocumentsTitle')}>
          {translate('EventWidgets_Speakers_Modal_Documents__resx')}
        </div>
        <ul {...resolve(rest, 'speakerLinks')}>
          {[
            renderDocuments(documents, rest)
          ]}
        </ul>
      </div>
    );
  }
  return (<div />);
}

export default (connect((state, props) => {
  const { speakerId, translate, classes, style, getSpeakerDocuments, onDocumentDownload } = props;
  const documents = getSpeakerDocuments(state, speakerId);
  return {
    translate,
    classes,
    style,
    documents,
    speakerId,
    onDocumentDownload
  };
})(SpeakerDocuments));
